var _rect, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 224,
    viewBox: "0 0 242 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.104,
    y: 1,
    width: 239.792,
    height: 222,
    rx: 6,
    fill: "#F5F7FB",
    stroke: "#F1F2FA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H204Z",
    fill: "#F5F7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H204",
    stroke: "#6324C6",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.8965 37H222.5",
    stroke: "#E2E5E9",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 143,
    x2: 167.088,
    y2: 143,
    stroke: "#774DC5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 151,
    y1: 162,
    x2: 204.859,
    y2: 162,
    stroke: "#6324C6",
    strokeOpacity: 0.13,
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 80,
    x2: 167.088,
    y2: 80,
    stroke: "#774DC5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 151,
    y1: 99,
    x2: 204.859,
    y2: 99,
    stroke: "#6324C6",
    strokeOpacity: 0.13,
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 152,
    x2: 33.0885,
    y2: 152,
    stroke: "#774DC5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 163,
    x2: 96,
    y2: 163,
    stroke: "#6324C6",
    strokeOpacity: 0.13,
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 112L18.7485 108.796C21.7587 103.28 27.5412 99.8478 33.8254 99.8478H34.9277C38.6235 99.8478 42.1781 101.267 44.8573 103.813V103.813C49.8609 108.567 57.5322 109.108 63.153 105.102L68.1259 101.558C69.719 100.423 71.1521 99.0789 72.3869 97.5617L88.4556 77.8174C92.996 72.2384 99.8069 69 107 69V69",
    stroke: "#9B6CE4",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/topic.2b065279bc82a4711c4eb2790b8da238.svg";
export { ForwardRef as ReactComponent };